import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppState } from "src/app/app.reducer";
import { Store } from "@ngrx/store";
import { map, first, tap } from "rxjs/operators";
import { GetUsersGroups, DeleteGroup, GetUserGroupsSuccess } from "../store/user-groups.actions";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { AddGroupComponent } from "../add-group/add-group.component";
import { group } from "@angular/animations";
import { NotificationModalComponent } from "../../../common-components/notification-modal/notification-modal.component";
import { CommonService } from "src/app/services/tasks.services";
import { NotificationsService } from 'angular2-notifications';
import { NgxPermissionsService } from "ngx-permissions";


@Component({
  selector: "app-user-groups",
  templateUrl: "./user-groups.component.html",
  styleUrls: ["./user-groups.component.scss"]
})
export class UserGroupsComponent implements OnInit {
  displayedColumns = ["group-name", "description", "members", "actions", "status"];
  userGroups$;
  hideEditGroup: boolean;
  hideViewGroup: boolean;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private commonService: CommonService,
    private ngxPermissionservice: NgxPermissionsService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetUsersGroups());
    this.userGroups$ = this.store.select(state => state.userGroups.groups);
    this.hideEditGroup = !Object.keys(this.ngxPermissionservice.getPermissions()).includes('edit-group')
  }

  goToAddGroup() {
    // this.commonService.NewUserButtonClicked =true;
    const dialogRef = this.dialog.open(AddGroupComponent, {
      width: "60%",
      panelClass: "cmp-modal",
    });
    dialogRef
      .afterClosed()
      .subscribe(result => {
        if (result && result.type === 'createGroup') {
          this.notificationService.success('Group created successfully');
          this.store.dispatch(new GetUsersGroups());
        }
        if (result && result === 'getUserDetails') {

        }
      });
  }

  goToGroupDetail(group) {
    this.router.navigate([group._id], { relativeTo: this.activatedRoute });
  }

  removeConfirmation(groupId) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: "500px",
      panelClass: 'cmp-modal',
      data: {
        text: "Are you sure you want to make changes to this group?",
        type: 'userGroups'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(new DeleteGroup(groupId));
      }
      else {
        this.store.dispatch(new GetUsersGroups());
      }
    });
    // for inactive state we are using the same dispatch action written for delete
    // this.store.dispatch(new DeleteGroup(groupId))
  }

  goToGroupDetailView(group) {
    this.hideViewGroup = Object.keys(this.ngxPermissionservice.getPermissions()).includes('view-all-groups');
    if (this.hideViewGroup) {
      this.router.navigate([group._id, 'view'], { relativeTo: this.activatedRoute });
    }
  }
}
